// PromotionModal — shown when a pawn lands on its last rank. Per
// rulebook the pawn MUST be promoted; the modal is intentionally
// NON-DISMISSIBLE: backdrop clicks / ESC / back-button do nothing
// until the player picks one of Queen / Rook / Bishop / Knight.
// (Rulebook: "It cannot remain a Pawn or become a King.")
//
// The pieces render in the player's own colour — wK / bK art flipped
// per viewer-side so the options look like "your promotion options".

import { playTap } from './sounds';

type PromoPiece = 'q' | 'r' | 'b' | 'n';

type Props = {
  open: boolean;
  /** 'w' | 'b' — piece colour to display (always the viewer's side). */
  side: 'w' | 'b';
  onPick: (piece: PromoPiece) => void;
};

const OPTIONS: Array<{ piece: PromoPiece; label: string }> = [
  { piece: 'q', label: 'Queen'  },
  { piece: 'r', label: 'Rook'   },
  { piece: 'b', label: 'Bishop' },
  { piece: 'n', label: 'Knight' },
];

export default function PromotionModal({ open, side, onPick }: Props) {
  if (!open) return null;
  return (
    <div
      className="chess-promo-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Pawn promotion"
      // Deliberately NO backdrop onClick — the modal is non-dismissible.
    >
      <div className="chess-promo-panel">
        <div className="chess-promo-title">PROMOTE</div>
        <div className="chess-promo-grid">
          {OPTIONS.map(({ piece, label }) => (
            <button
              key={piece}
              type="button"
              className="chess-promo-tile"
              onClick={() => { playTap(); onPick(piece); }}
              aria-label={`Promote to ${label}`}
              title={label}
            >
              <img
                src={`/games/chess/pieces/${side}${piece.toUpperCase()}.png`}
                alt=""
                className="chess-promo-piece"
                draggable={false}
              />
              <span className="chess-promo-label">{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
